export default __webpack_public_path__ + "static/media/lb-hackathon-level-5.4e303e2d.svg";